import * as React from 'react';
import cx from 'classnames';
import { Close12, Close16 } from '../../../icons';
import { getStyles } from './styles';
export function CloseButton(_ref) {
  var onClick = _ref.onClick,
    tabIndex = _ref.tabIndex,
    size = _ref.size,
    theme = _ref.theme,
    className = _ref.className;
  var Icon = size === 12 ? Close12 : Close16;
  var styles = getStyles(theme);
  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['close'], className),
    onClick: onClick,
    role: "button",
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    tabIndex: tabIndex || 0
  }, /*#__PURE__*/React.createElement(Icon, {
    color: 'current_color'
  }));
}